import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { Category } from '../models';
import { MAX_FETCH_PROGRESS, retrieveFullPaginatedData } from '../pagination';
import { toBooleanValueFields } from '../transform';
import { BOOLEAN_VALUE, type MappedCategoryResponse } from '../types';

export class CategoryService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert(
        lastSyncTime?: string,
        progressCallback?: (progress: number) => void,
    ) {
        const params = {
            timestamp: lastSyncTime ?? null,
            isActive: lastSyncTime ? null : true,
        };

        await retrieveFullPaginatedData<MappedCategoryResponse>(
            REGISTERS_API_URL.PRODUCT.CATEGORIES,
            params,
            async (data, progress) => {
                await this.bulkUpsert(data);
                progressCallback?.(progress);
            },
        );

        progressCallback?.(MAX_FETCH_PROGRESS);
    }

    async bulkUpsert(categories: MappedCategoryResponse[]) {
        const output = categories.map((category) => {
            return toBooleanValueFields(category, ['deleted']);
        });

        await this.db.categories.bulkPut(output as unknown as Category[]);
    }

    async getById(id: string) {
        return this.db.categories
            .where('[id+deleted]')
            .equals([id, BOOLEAN_VALUE.FALSE])
            .first();
    }
}
